import { render } from "./CrudBase.vue?vue&type=template&id=287a9548"
import script from "./CrudBase.vue?vue&type=script&lang=js"
export * from "./CrudBase.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__